import fetchCompanies from './fetchCompanies';
import filterCompanies from './filterCompanies';

export default {
    fetchCompanies,
    filterCompanies,
};
